import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { coreAPI } from '../../services/api';
import { LoadingPage } from '../../components/Loading';
import './PageView.css';

const PageView = () => {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchPage();
  }, [slug]);

  const fetchPage = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await coreAPI.getPage(slug);
      setPage(response.data);
    } catch (error) {
      console.error('Error fetching page:', error);
      setError('無法載入頁面內容');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <LoadingPage />;
  }

  if (error || !page) {
    return (
      <div className="page-view">
        <div className="container">
          <div className="error-message">
            <h2>{error || '找不到頁面'}</h2>
            <p>請返回首頁或聯絡我們。</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="page-view">
      <div className="container">
        <div className="page-header">
          <h1>{page.title}</h1>
        </div>
        <div className="page-content">
          <div 
            className="content-text" 
            dangerouslySetInnerHTML={{ __html: page.content || '' }}
          />
        </div>
      </div>
    </div>
  );
};

export default PageView;
